import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import { withRouter } from 'react-router-dom';
import ShopSection from './ShopSection';
import ShopSectionContainer from './ShopSection.container';

import ShopSectionDas from './ShopSection.digital_assets';

export default withRouter(
  withFeatureBranch({
    digital_assets: ShopSectionContainer(ShopSectionDas),
  })(ShopSectionContainer(ShopSection))
);
